module.exports = __webpack_public_path__ + "img/Scaffolding servicies on the oil rig platform.c8753a82.png";